module.exports = __webpack_public_path__ + "static/media/cabbage.3ce25a8f.png";